import apiClient from './api'
import type { ApiProduct, CreateProductDto, UpdateProductDto } from '@/types/api-product'

/**
 * Servicio para manejar operaciones de productos
 */
export const productService = {
  /**
   * Obtener todos los productos
   */
  async getAll(): Promise<ApiProduct[]> {
    const response = await apiClient.get<ApiProduct[]>('/api/products')
    return response.data
  },

  /**
   * Obtener un producto por ID
   */
  async getById(id: number): Promise<ApiProduct> {
    const response = await apiClient.get<ApiProduct>(`/api/products/${id}`)
    return response.data
  },

  /**
   * Crear un nuevo producto
   */
  async create(product: CreateProductDto): Promise<ApiProduct> {
    const response = await apiClient.post<ApiProduct>('/api/products', product)
    return response.data
  },

  /**
   * Actualizar un producto existente
   */
  async update(id: number, product: UpdateProductDto): Promise<ApiProduct> {
    const response = await apiClient.put<ApiProduct>(`/api/products/${id}`, product)
    return response.data
  },

  /**
   * Eliminar un producto
   */
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/products/${id}`)
  },
}

